import React from 'react';
import './videoplayer.scss';

export default function VideoPlayer() {
    return <div className="video-player"><video controls playsInline preload="none" aria-label="Discover Our Vision: GOLDWrench Automotive" width="1280" height="720">
        <source src="https://vid.hellonetcdn.com/vid/va/augustacounty/biz/vaaugustco23_62_iwd_xtlrg_univ.mp4" type="video/mp4" />
        Your browser does not support embedded video.
    </video></div>;
}
